var _g, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 84,
    viewBox: "0 0 85 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2169_14183)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 42.5077,
    cy: 33.2956,
    r: 29.1034,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.114 28.4603C32.114 27.3122 33.0447 26.3815 34.1928 26.3815H37.3111L39.3096 24.5046C39.695 24.1427 40.2039 23.9412 40.7327 23.9412H44.2835C44.8123 23.9412 45.3212 24.1427 45.7066 24.5046L47.7051 26.3815H50.8234C51.9715 26.3815 52.9022 27.3122 52.9022 28.4603V40.5717C52.9022 41.7198 51.9715 42.6505 50.8234 42.6505H34.1928C33.0447 42.6505 32.114 41.7198 32.114 40.5717V28.4603Z",
    fill: "#363D4E",
    stroke: "#363D4E",
    strokeWidth: 1.87094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.017 34.0753C48.017 34.1622 48.015 34.2488 48.011 34.3351H49.8289C49.9437 34.3351 50.0368 34.4282 50.0368 34.543C50.0368 34.5953 50.0171 34.6456 49.9817 34.684L47.3382 37.5477C47.2604 37.6321 47.1288 37.6373 47.0445 37.5595L44.3893 34.684C44.3114 34.5996 44.3167 34.4681 44.4011 34.3903C44.4395 34.3548 44.4898 34.3351 44.5421 34.3351H46.3454C46.3511 34.249 46.354 34.1624 46.354 34.0753C46.354 31.9513 44.6321 30.2295 42.5082 30.2295C41.8822 30.2295 41.28 30.3788 40.7411 30.6583L39.5843 29.4056C40.4515 28.8615 41.4584 28.5664 42.5082 28.5664C45.5506 28.5664 48.017 31.0328 48.017 34.0753ZM37.0055 33.8104H35.1874C35.1351 33.8104 35.0848 33.7907 35.0464 33.7553C34.962 33.6774 34.9567 33.5459 35.0346 33.4615L37.6898 30.586C37.7742 30.5082 37.9057 30.5134 37.9836 30.5978L40.627 33.4615C40.6624 33.4999 40.6821 33.5502 40.6821 33.6025C40.6821 33.7173 40.589 33.8104 40.4742 33.8104H38.6712C38.6653 33.8982 38.6623 33.9865 38.6623 34.0753C38.6623 36.1992 40.3841 37.9211 42.5081 37.9211C43.1341 37.9211 43.7363 37.7717 44.2752 37.4922L45.432 38.7449C44.5648 39.289 43.5579 39.5841 42.5081 39.5841C39.4657 39.5841 36.9992 37.1177 36.9992 34.0753C36.9992 33.9867 37.0013 33.8984 37.0055 33.8104Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2169_14183",
    x: 0.93139,
    y: 0.034503,
    width: 83.1526,
    height: 83.1526,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4.15764,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_2169_14183"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8.31527
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.31527
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2169_14183"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2169_14183",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.331e9176de0b46a1a1cf5939bf2d8176.svg";
export { ForwardRef as ReactComponent };